import { formatAmount } from '~/@lib/utils/number.utils'
import { type MultiselectOption } from '~/@pages_investing/projects/_projects_filtering/MultiSelect'

export const investmentValueOptions: Array<
  MultiselectOption<Record<string, any>>
> = [
  { label: `< ${formatAmount(500)}`, value: { max: 500 } },
  {
    label: ` ${formatAmount(500)} - ${formatAmount(1_000)}`,
    value: { min: 500, max: 1_000 },
  },
  {
    label: `${formatAmount(1_000)} - ${formatAmount(5_000)}`,
    value: { min: 1_000, max: 5_000 },
  },
  { label: `> ${formatAmount(5_000)}`, value: { min: 5_000 } },
]
